import { createSelector } from 'reselect';
import { GlobalAppState } from '@model/state';
import { TripTypes } from '@model/common/tours/trip-types';
import { getToursStateNameByType } from '@util/tours';
import { TourType } from '@model/search';
import { getFromTourReference } from '@state/slices/tours/tour-references';

// Base selectors
export const selectTourSearchState = (state: GlobalAppState) => state.search.tours;

export const getSearchParams = (tripType: TripTypes) =>
  createSelector(selectTourSearchState, (tourSearch) => tourSearch.searchParams[tripType]);

export const getToursByType = (tripType: TripTypes) =>
  createSelector(selectTourSearchState, (tourSearch) => {
    const stateName = getToursStateNameByType(tripType);
    return tourSearch[stateName];
  });

export const getIsTourSearchTypeByType = (tripType: TripTypes) =>
  createSelector(
    getToursByType(tripType),
    getFromTourReference,
    (tours, fromTourReference) => tours.length === 1 && (tours[0].type === TourType.TOUR || !!fromTourReference)
  );

export const getTourLandingSearch = createSelector(selectTourSearchState, (tourSearch) => tourSearch.tourLandingSearch);
